import { Avatar, CheckboxGroup, InputCheckbox, Dialog } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import FormField from 'ui/molecules/FormField/FormField';
import InputText from 'ui/atoms/InputText/InputText';
import { useDialogAssignStudents } from './useDialogAssignStudents';

function DialogAssignStudents({ open, students, onCancel, onSuccess, loading, isReadOnly }) {
  const { t, filteredStudents, searchTerm, studentsCount, hasChanges, handleToggle, handleSearchChange, handleSave, handleCancel } = useDialogAssignStudents({
    students,
    onSuccess,
    onCancel,
    open,
  });

  return (
    <Dialog
      buttonTextCancel={t('actions:Cancel')}
      buttonTextSuccess={`${t('actions:Save')} (${studentsCount})`}
      className="dialog-assign-students"
      isDisabledSuccess={!hasChanges || isReadOnly}
      isLoading={loading}
      onCancel={handleCancel}
      onClose={handleCancel}
      onSuccess={handleSave}
      isOpen={open}
      hasSeparator={true}
      size="s"
      title={t('common:Assign students')}
    >
      <div className="dialog-assign-students__content">
        <div className="dialog-assign-students__search">
          <FormField isLabelHidden label={t('common:Search')}>
            <InputText icon="search" iconLeft={true} onChange={handleSearchChange} placeholder={t('placeholder:Search')} value={searchTerm} />
          </FormField>
        </div>

        <div className="dialog-assign-students__list">
          <CheckboxGroup isLegendHidden legend={t('common:Assign students')}>
            {filteredStudents.map((student) => (
              <InputCheckbox
                key={student.id}
                checked={student.selected}
                disabled={student.disabled || isReadOnly}
                label={
                  <span className="dialog-assign-students__item-label">
                    <Avatar image={student.thumbnail} size="sm" />
                    <span className="dialog-assign-students__item-name">{student.name}</span>
                  </span>
                }
                onChange={() => handleToggle(student.id)}
              />
            ))}
          </CheckboxGroup>
        </div>
      </div>
    </Dialog>
  );
}

DialogAssignStudents.propTypes = {
  isReadOnly: PropTypes.bool,
  loading: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
  students: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      id: PropTypes.string,
      name: PropTypes.string,
      selected: PropTypes.bool,
      thumbnail: PropTypes.string,
    })
  ),
};

DialogAssignStudents.defaultProps = {
  onCancel: function () {},
  onSuccess: function () {},
  open: false,
  students: [],
};

export default DialogAssignStudents;
